import fetch from 'utils/fetch';

export const REQUEST_RECIPIENTS = 'REQUEST_RECIPIENTS';
export const RECEIVE_RECIPIENTS = 'RECEIVE_RECIPIENTS';
export const FILTER_RECIPIENTS = 'FILTER_RECIPIENTS';

function requestRecipients() {
  return {
    type: REQUEST_RECIPIENTS,
  };
}

export function receiveRecipients(recipients) {
  return {
    type: RECEIVE_RECIPIENTS,
    payload: {
      recipients,
    },
  };
}

function fetchRecipients() {
  return dispatch => {
    dispatch(requestRecipients());
    fetch('/messaging/recipients.json')
      .then(r => r.json())
      .then(recipients => dispatch(receiveRecipients(recipients)));
  };
}

function shouldFetchRecipients(state) {
  const { loaded, isFetching, didInvalidate } = state.messaging.recipients;
  if (!loaded) {
    return true;
  } else if (isFetching) {
    return false;
  }

  return didInvalidate;
}

export function fetchRecipientsIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchRecipients(getState())) {
      return dispatch(fetchRecipients());
    }
  };
}

export function filterRecipients(filter) {
  return {
    type: FILTER_RECIPIENTS,
    payload: {
      filter,
    },
  };
}



// WEBPACK FOOTER //
// ./src/modules/messaging/actions/recipient.js